<template>
    <div class="card">
        <div style="border:1px solid #ccc;height:85vh;padding:20px">
            <div>
                <div class="field">
                 <span class="p-float-label">
                    <Dropdown v-model="project" style="width:220px" @change="onProjectChange"
                              :options="projectOptions" option-value="projectId"
                              optionLabel="projectName">
                   </Dropdown>
                    <label for="status">Project</label>
                  </span>
                </div>
                <div class="field">
                 <span class="p-float-label">
                    <InputText id="spec" v-model="projectPm" style="width:220px" type="text"></InputText>
                    <label for="status">PM</label>
                  </span>
                </div>
                <div class="field">
                 <span class="p-float-label">
                    <InputText id="spec" v-model="Title" style="width:320px" type="text"></InputText>
                    <label for="status">Title</label>
                  </span>
                </div>
                <div class="field">
                 <span class="p-float-label">
                    <Textarea
                        id="placeOfBirth"
                        v-model="Message"
                        style="width:88%;height:50vh"
                    />
                    <label for="status">Message</label>
                  </span>
                </div>
            </div>
            <div>
                <Button style="float:right;margin-right:200px" @click="submitClick" label="Submit"></Button>
            </div>
        </div>
    </div>
</template>
<script>
import requests from '@/request';
export default {
    name: 'Contact',
    data() {
        return {
            micAccountName: localStorage.getItem('micAccountName'),
            project: null,
            projectOptions: [],
            projectPm: '',
            email : '',
            Title: '',
            Message: '',
            projectId:'',
            projectName : '',
        };
    },

    methods: {
        onProjectChange() {

            this.projectPm=this.projectOptions.find((item) => item.projectId === this.project).pm;
            this.projectId = this.projectOptions.find((item) => item.projectId === this.project).projectId;
            this.projectName =this.projectOptions.find((item) => item.projectId === this.project).projectName;
            this.email = this.projectOptions.find((item) => item.projectId === this.project).pmEmail;
        },
        submitClick() {
            requests({
                url: '/user/SendEmail',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                },
                data: {
                    title: this.Title,
                    message: this.Message,
                    email : this.email,
                    projectId: this.projectId,
                    projectName:this.projectName,
                    sendEmail: this.micAccountName
                },
            }).then((res) => {
                if(res.data.data.success){
                    this.$toast.add({ severity: 'success', summary: 'Send Successfully',  life: 3000 });
                }else{
                    this.$toast.add({ severity: 'warn', summary: 'Send Failed{}'+res.data.data.msg, life: 3000 });
                }
            });
        },
    },
    created(){
        requests({
            url: '/user/showEmailMessage',
            data: {
                micAccountName: this.micAccountName
            }
        }).then(res => {
            this.projectOptions =  res.data.data;
        })
    },
};
</script>
<style lang="scss" scoped>
.field{
    margin-bottom: 20px;
}
</style>